WL.registerComponent('grabbable', {
    alternative: { type: WL.Type.Object }
}, {
    init: function () {
        this.myIsGrabbed = false;
        if (!this.alternative) {
            this.alternative = this.object;
        }
        this._myOldParent = this.alternative.parent;
        this._myUngrabCallbacks = new Map();
        this._myGrabCallbacks = new Map();
    },
    start: function () {
        this.myPhysx = this.alternative.getComponent('physx');
    },
    registerUngrabEventListener(id, callback) {
        this._myUngrabCallbacks.set(id, callback);
    },
    unregisterUngrabEventListener(id) {
        this._myUngrabCallbacks.delete(id);
    },
    registerGrabEventListener(id, callback) {
        this._myGrabCallbacks.set(id, callback);
    },
    unregisterGrabEventListener(id) {
        this._myGrabCallbacks.delete(id);
    },
    grab: function (grabber) {
        if (this.myIsGrabbed) {
            this._ungrab();
        }

        if (this.myPhysx) {
            this.myPhysx.kinematic = true;
        }

        this._myOldParent = this.alternative.parent;

        PP.ObjectUtils.reparentKeepTransform(this.alternative, grabber);

        this.myIsGrabbed = true;

        this._myGrabCallbacks.forEach(function (value) { value(grabber); });
    },
    throw: function (linearVelocity, angularVelocity) {
        if (this.myIsGrabbed) {

            PP.ObjectUtils.reparentKeepTransform(this.alternative, this._myOldParent);
            this.myIsGrabbed = false;
            if (this.myPhysx) {
                this.myPhysx.kinematic = false;
                this.myPhysx.linearVelocity = linearVelocity;
                this.myPhysx.angularVelocity = angularVelocity;
            }
            this._myUngrabCallbacks.forEach(function (value) { value(); });
        }
    },
    _ungrab() {
        this._myUngrabCallbacks.forEach(function (value) { value(); });
        this.myIsGrabbed = false;
        PP.ObjectUtils.reparentKeepTransform(this.alternative, this._myOldParent);

    }
});